export function ImagemErro(props) {
  return (
    <svg
      width={306}
      height={200}
      viewBox="0 0 306 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.69 181.509S9.388 164.58 25.746 148.747c16.354-15.832 21.248-13.871 16.539-31.518S18.506 93.017 26.088 79.626c9.102-16.074 29.852-1.41 42.75 4.218 23.978 10.465 23.834-5.178 14.625-19.813-9.208-14.635-9.87-39.036 11.397-39.036 23.131 0 73.965 47.609 101.97 80.511 16.76 19.692 28.976 5.99 27.279-6.661-1.079-8.04-3.323-21.038 1.929-27.019 9.116-10.38 35.895 22.14 45.35 36.035 37.005 54.38-7.977 73.648-7.977 73.648H36.691z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.518 39.672c1.037-2.383 1.369-4.208.633-5.713-2.183-4.462-13.309-5.177-20.435-.836-9.938 6.054-12.566 22.225-8.017 25.815 5.294 4.178 22.467-6.968 27.819-19.266z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.05 157.03H216.23V54.445H91.051V157.03z"
        fill="#fff"
      />
      <path
        d="M155.507 88.709c-.656-1.242-2.695-1.242-3.351 0l-17.059 32.268a1.898 1.898 0 001.676 2.787h34.117a1.89 1.89 0 001.623-.919 1.893 1.893 0 00.051-1.866l-17.057-32.27zm.22 29.36h-3.791v-3.796h3.791v3.796zm-3.791-7.592v-9.491h3.791l.002 9.491h-3.793z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.98 60.414h125.178V48.898H90.981v11.516z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.268 54.657c0 .76-.615 1.375-1.373 1.375a1.374 1.374 0 01-1.372-1.375c0-.76.615-1.375 1.372-1.375.758 0 1.373.615 1.373 1.375z"
        fill="#1DB37C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204.441 54.657c0 .76-.614 1.375-1.372 1.375a1.373 1.373 0 01-1.372-1.375c0-.76.614-1.375 1.372-1.375.758 0 1.372.615 1.372 1.375z"
        fill="#FFD169"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.613 54.657c0 .76-.615 1.375-1.372 1.375a1.373 1.373 0 01-1.372-1.375c0-.76.614-1.375 1.372-1.375.757 0 1.372.615 1.372 1.375zM96.252 70.78h12.342v-4.806H96.252v4.807z"
        fill="#FF7A5C"
      />
      <path
        d="M147.691 134.431c.718 0 1.287.19 1.707.571.419.381.629.9.629 1.558 0 .762-.239 1.357-.717 1.787-.475.426-1.151.64-2.029.64-.796 0-1.422-.129-1.877-.386v-1.04c.264.15.566.265.907.346.341.082.658.123.951.123.517 0 .91-.116 1.18-.347.27-.231.405-.57.405-1.016 0-.853-.543-1.279-1.629-1.279a4 4 0 00-.566.049c-.224.029-.42.063-.589.102l-.512-.302.273-3.487h3.705v1.021h-2.696l-.161 1.767.414-.068c.166-.026.368-.039.605-.039zM155.809 135.32c0 1.24-.2 2.161-.599 2.763-.397.602-1.005.904-1.824.904-.793 0-1.395-.311-1.804-.933-.41-.622-.614-1.533-.614-2.734 0-1.26.198-2.188.594-2.784.4-.599 1.008-.898 1.824-.898.796 0 1.399.312 1.809.937.409.625.614 1.54.614 2.745zm-3.681 0c0 .973.099 1.668.297 2.085.202.416.522.625.961.625.439 0 .759-.212.961-.635.204-.423.307-1.115.307-2.075 0-.957-.103-1.649-.307-2.076-.202-.429-.522-.644-.961-.644-.439 0-.759.21-.961.63-.198.42-.297 1.116-.297 2.09zM161.514 135.32c0 1.24-.2 2.161-.6 2.763-.396.602-1.004.904-1.823.904-.793 0-1.395-.311-1.804-.933-.41-.622-.615-1.533-.615-2.734 0-1.26.199-2.188.595-2.784.4-.599 1.008-.898 1.824-.898.796 0 1.399.312 1.809.937.409.625.614 1.54.614 2.745zm-3.681 0c0 .973.099 1.668.297 2.085.202.416.522.625.961.625.438 0 .759-.212.96-.635.205-.423.307-1.115.307-2.075 0-.957-.102-1.649-.307-2.076-.201-.429-.522-.644-.96-.644-.439 0-.759.21-.961.63-.198.42-.297 1.116-.297 2.09z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.777 186.334h83.956v-.478h-83.956v.478zM198.221 191.111h36.73v-.477h-36.73v.477zM119.99 191.111h66.783v-.477H119.99v.477zM69.902 191.111H79.92v-.477H69.902v.477zM82.783 191.111h2.862v-.477h-2.862v.477zM228.752 186.812h17.173v-.478h-17.173v.478zM101.863 186.334H128.1v-.478h-26.237v.478zM51.299 186.334h45.317v-.478H51.299v.478zM37.465 186.334h8.11v-.478h-8.11v.478zM18.861 182.512h260.454v-.477H18.861v.477z"
        fill="#FF7A5C"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M246.572 72.259c-.987 4.568-2.64 8.966-3.96 13.45-1.358 4.614-2.728 9.308-2.712 14.118.022 6.256 2.506 12.472 6.805 17.021 1.683 1.783 3.65 3.341 4.947 5.421 1.297 2.081 1.776 4.939.327 6.917-2.09 2.854-6.561 2.236-9.618 4.019-3.848 2.245-4.383 7.966-2.189 11.842 2.194 3.876 12.185 14.965 26.441 12.219 6.381-1.229 15.03-7.297 14.783-13.786-.257-6.758-6.713-12.231-6.493-18.989.143-4.427 3.122-8.169 5.701-11.773 2.578-3.603 4.98-7.993 3.793-12.261-1.748-6.283-9.844-8.223-13.765-13.436-2.525-3.357-3.081-7.772-3.238-11.968-.157-4.197-.05-8.497-1.45-12.456-3.398-9.603-15.459-8.457-19.372 9.662z"
        fill="#1DB37C"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.059 169.037h.985V96.565h-.985v72.472z"
        fill="#B3472E"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.731 117.764l-.672-.112c1.101-6.813 8.715-11.05 9.039-11.227l.323.611c-.077.042-7.643 4.255-8.69 10.728zM261.367 146.359c-.749-4.407-6.168-7.275-6.222-7.304l.324-.584c.235.122 5.771 3.055 6.574 7.78l-.676.108z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.57 182.349h-7.547c-4.583 0-8.298-3.723-8.298-8.314v-6.97h24.144v6.97c0 4.591-3.716 8.314-8.299 8.314z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M249.725 170.023h24.144v-.986h-24.144v.986zM90.687 117.651a.721.721 0 11-1.442.002.721.721 0 011.442-.002z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.74 152.839h27.667v-19.063H22.74v19.063z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.61 133.792h-.576v-2.888h-6.917v2.888h-.576v-3.466h8.07v3.466z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.988 72.255a2.608 2.608 0 01-1.95 3.23l-9.27 2.053-2.245-10.178c-.683-3.095 1.268-6.16 4.357-6.844 1.49-.33 3.236-.1 4.451.638a5.716 5.716 0 012.565 3.402l2.092 7.699z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.982 76.878l-6.534 1.447-1.575-7.14 8.322-1.844 1.346 4.952a2.086 2.086 0 01-1.559 2.585z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.72 75.91l-9.35 1.665-1.82-10.263a5.74 5.74 0 014.639-6.657c3.008-.535 6.163 1.345 6.843 4.331l1.769 7.778a2.607 2.607 0 01-2.082 3.146z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.983 76.878l-3.53.782-1.574-7.141 5.317-1.178 1.346 4.952a2.086 2.086 0 01-1.559 2.585z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.51 85.002a3.606 3.606 0 01-3.602-3.61V71.054h7.205v10.338a3.607 3.607 0 01-3.602 3.61z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.068 91.978l15.737-10.476-3.676-6.924-17.451 7.248 5.39 10.152z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.681 83.97a5.785 5.785 0 01-1.612 8.008 5.756 5.756 0 01-7.99-1.616 5.784 5.784 0 011.612-8.008 5.756 5.756 0 017.99 1.615z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.31 132.774a2.308 2.308 0 002.544-2.045 2.31 2.31 0 00-2.04-2.549 2.307 2.307 0 00-2.544 2.044 2.31 2.31 0 002.04 2.55z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.386 128.246a1.732 1.732 0 01.378-3.445c.95.105 1.634.961 1.53 1.912a1.73 1.73 0 01-1.908 1.533z"
        fill="#FF95A9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.432 129.589l1.546-3.731 3.316.855-.441 4.016-4.421-1.14z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.986 90.5l-9.967-5.696-7.74 17.27.002.001a3.945 3.945 0 00-.33 1.943h-.003l1.66 19.759.145 1.724.098 1.168 3.443.042 2.369-21.581L51.986 90.5z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.652 123.438l-.36 3.273-3.442-.042-.099-1.167-.144-1.725 4.045-.339z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.852 126.67l3.443.042.166-1.521-3.707.312.098 1.167z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.952 91.882a5.756 5.756 0 008.034-1.38 5.784 5.784 0 00-1.378-8.052 5.755 5.755 0 00-8.034 1.38 5.784 5.784 0 001.378 8.052z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.393 118.358l-1.199 24.475h-6.666l-.003-24.475h7.868z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.63 118.359a3.938 3.938 0 01-3.934 3.942 3.938 3.938 0 01-3.934-3.942 3.938 3.938 0 013.934-3.943 3.938 3.938 0 013.933 3.943zM65.393 118.359a3.938 3.938 0 01-3.934 3.942 3.938 3.938 0 01-3.934-3.942 3.938 3.938 0 013.934-3.943 3.938 3.938 0 013.934 3.943z"
        fill="#7760DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.587 114.416l-.202 4.136a3.937 3.937 0 01-3.93 3.749H48.705a3.937 3.937 0 01-3.93-3.749l-.202-4.136h21.015z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.003 179.61a2.435 2.435 0 01-2.432 2.437 2.434 2.434 0 01-2.432-2.437 2.435 2.435 0 012.432-2.438 2.436 2.436 0 012.432 2.438zM62.39 179.61a2.435 2.435 0 01-2.433 2.437 2.434 2.434 0 01-2.432-2.437 2.435 2.435 0 012.432-2.438 2.436 2.436 0 012.433 2.438z"
        fill="#7760DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.195 142.833a3.336 3.336 0 01-3.333 3.34 3.336 3.336 0 01-3.333-3.34 3.336 3.336 0 013.333-3.34 3.336 3.336 0 013.333 3.34z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.526 179.61v-36.777h6.665l-1.8 36.777h-4.865zM65.587 114.416c0 5.816-4.704 10.531-10.508 10.531-5.803 0-10.507-4.715-10.507-10.531 0-5.815 4.704-10.53 10.508-10.53 5.803 0 10.507 4.715 10.507 10.53z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.996 85.63l-1.409 28.786H44.572l-1.409-28.785a4.04 4.04 0 014.03-4.242h15.774a4.04 4.04 0 014.03 4.242z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.84 182.498h-7.315v-2.889h4.868l2.793 1.527a.725.725 0 01-.346 1.362zM62.409 59.62l.667 3.027c.052.234.074.467.066.695l-5.683 1.259-1.49-6.76 2.718-.601a3.121 3.121 0 013.722 2.38zM51.36 60.291l.762-.168 2.113 9.583L48.394 71l-.991-4.492a5.215 5.215 0 013.958-6.217z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.353 62.837l-6.04 1.337a4.385 4.385 0 01-5.223-3.339 2.08 2.08 0 114.064-.9.218.218 0 00.26.166l6.04-1.338.899 4.074z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.743 61.278l-3.132.694a2.086 2.086 0 01-.898-4.073l3.133-.694a2.086 2.086 0 01.898 4.073z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.328 61.849a3.52 3.52 0 01-2.672 4.196c-1.894.42-4.022-.723-4.441-2.62-.418-1.899 1.031-3.834 2.925-4.253a3.512 3.512 0 014.188 2.677z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.604 64.883l-8.467 1.876-.702-3.182 8.468-1.876.701 3.182z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.6 72.231l8.032-1.78-1.227-5.568-8.034 1.78L53.6 72.23z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.468 72.897l-9.527 2.11a2.602 2.602 0 01-3.101-1.983l-.615-2.788 12.067-2.673 1.176 5.334z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.103 70.247l.704-.156-.478-2.168-.704.156a1.11 1.11 0 00.478 2.168z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.908 81.391h7.205v-1.528h-7.205v1.528z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.773 118.057l-4.629 61.366 4.839.492 7.616-61.063-7.826-.795z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.453 182.498H40.14v-2.889h4.867l2.794 1.527a.725.725 0 01-.347 1.362z"
        fill="#22343E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.283 76.156a3.945 3.945 0 001.288 5.42 3.926 3.926 0 005.408-1.292 3.944 3.944 0 00-1.288-5.42 3.926 3.926 0 00-5.408 1.291z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.335 62.711a2.304 2.304 0 012.974-1.338 2.312 2.312 0 011.336 2.98 2.304 2.304 0 01-2.975 1.34 2.312 2.312 0 01-1.335-2.982z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.848 63.812c-.34.895.109 1.896 1.002 2.236.892.34 1.89-.11 2.23-1.004a1.734 1.734 0 00-1.002-2.235 1.728 1.728 0 00-2.23 1.003z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.309 65.836l4.018.32.75-3.348-3.767-1.436-1.001 4.464z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.291 65.704l2.08-2.75 19.32 11.912-4.73 6.25L62.42 67.67l-1.27-1.172-.859-.794z"
        fill="#775298"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.291 65.704l2.08-2.75 2.798 1.725-2.75 2.992-1.269-1.173-.859-.794z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.291 65.702l2.08-2.75 1.301.803-2.522 2.741-.859-.794z"
        fill="#C68A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.103 52.928l-.678.164-.556-2.297c-.894-3.695-4.62-5.973-8.304-5.078-2.155.522-4.305-.268-5.612-2.064-1.307-1.795-1.403-4.088-.248-5.985l.596.364c-1.005 1.65-.922 3.647.215 5.21 1.138 1.561 3.01 2.25 4.884 1.795 4.06-.985 8.163 1.524 9.147 5.593l.556 2.298zM74.607 36.096h-.697v2.364c0 3.8-3.086 6.893-6.877 6.893-2.217 0-4.121 1.276-4.97 3.329-.848 2.052-.4 4.304 1.167 5.875l.493-.494c-1.364-1.368-1.753-3.327-1.015-5.114.739-1.786 2.396-2.896 4.325-2.896 4.177 0 7.574-3.406 7.574-7.593v-2.364zM54.64 52.062l-.58-.389.469-.704c2.917-4.38 1.736-10.323-2.634-13.25a10.19 10.19 0 01-4.351-6.523l-1.974-9.93.685-.136 1.973 9.93a9.495 9.495 0 004.054 6.078c4.69 3.14 5.959 9.52 2.827 14.22l-.47.704zM61.088 39.46h.698v-7.805h-.698v7.805z"
        fill="#FEC1AF"
      />
    </svg>
  );
}
